import {
  Alert as MuiAlert,
  AppBar as MuiAppBar,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TableCell as MuiTableCell,
  TextField as MuiTextField,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { spacing } from "@mui/system";
import styled from "styled-components/macro";

export const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.palette.appBar.background};
  color: ${(props) => props.theme.palette.appBar.color};
`;
export const Alert = styled(MuiAlert)(spacing);
export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
export const Button = styled(MuiButton)(spacing);
export const Card = styled(MuiCard)(spacing);
export const Divider = styled(MuiDivider)(spacing);
export const Paper = styled(MuiPaper)(spacing);
export const TableCell = styled(MuiTableCell)`
  &.${tableCellClasses.body} {
    padding: 0px;
    border: none;
  }
`;
export const TextField = styled(MuiTextField)(spacing);
